export default __webpack_public_path__ + "static/mechenism_a-491101d906de27ce61b7ccedfc200a2b.jpg";